let actions = {
  async custom({dispatch}, message = '') {
    dispatch('popups/show/error',{
      message: `There was an error ${message}. <br></br> Please try again.`
    }, {root: true})
  },
  async updating({dispatch}, message = '') {
    dispatch('popups/show/error',{
      message: `${message} could not be updated due to an error. <br></br> Please try again.`
    }, {root: true})
  },
  async creating({dispatch}, message = '') {
    dispatch('popups/show/error',{
      message: `${message} could not be created due to an error. <br></br> Please try again.`
    }, {root: true})
  },
  async sending({dispatch}, message = '') {
    dispatch('popups/show/error',{
      message: `${message} could not be sent due to an error. <br></br> Please try again.`
    }, {root: true})
  },
  async deleting({dispatch}, message = '') {
    dispatch('popups/show/error',{
      message: `${message} could not be deleted due to an error. <br></br> Please try again.`
    }, {root: true})
  },
  async uploading({dispatch}, message = '') {
    dispatch('popups/show/error',{
      message: `There was an error uploading ${message}. <br></br> Please try again.`
    }, {root: true})
  },

  async uploadingImageNoName({dispatch}) {
    dispatch('popups/show/error',{
      message: `Error during link image upload (no Space name). <br></br> Please try again.`
    }, {root: true})
  },
}

export default {
  namespaced: true,
  actions
};
